import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import IconButton from 'components/atoms/Button/IconButton';
import LeftSettingMenu from 'components/molecules/LeftSettingMenu';
import SideMenu from 'components/molecules/SideMenu';
import { isActiveCloseChatModal, isActiveResetModal, isActiveSettingMenu, isActiveSideMenu, disableAllMenu, isActiveQuickMenu, isActiveExpandImageModal } from 'modules/actions/statusMenu';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
/**
 * Chatting:Header
 */

const ChatHeader = ({ title, viewType }) => {
  const settingMenuStatus = useSelector(state => state.isActive.settingMenu);
  const sideMenuStatus = useSelector(state => state.isActive.sideMenu);
  const quickMenuStatus = useSelector(state => state.isActive.quickMenu);
  const expandImageModalStatus = useSelector(state => state.isActive.expandImageModal);
  const [bannerItems, setBannerItems] = useState([]);
  const [duration, setDuration] = useState(5000);

  useEffect(() => {
    // GET 배너 데이터
    const getBanner = async () => {
      const res = await axios.get('/chat/getBanner');
      setBannerItems(res.data.items);
    }
    getBanner();
  }, []);

  const sliderRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  useEffect(() => {
    // 배너 자동 슬라이드
    if(selectedIndex === 0 || selectedIndex === bannerItems.length + 1 || selectedIndex === bannerItems.length) {
      // 첫번째와 마지막(첫번재 복제본) 배너를 10초로 보이게끔
      setDuration(5000);
    }else {
      setDuration(10000);
    }
    const interval = setInterval(() => {
      // console.log('interval')
      if (!sliderRef.current) {
        return;
      }

      sliderRef.current.style.transition = `all 0.5s ease-in-out`;
      sliderRef.current.style.transform = `translateY(-${selectedIndex}00%)`;

      if (selectedIndex === bannerItems.length + 1) {
        sliderRef.current.style.transition = `0s`;
        sliderRef.current.style.transform = `translateY(0)`;
        setSelectedIndex(1);
      } else {
        setSelectedIndex(selectedIndex + 1);
      }
    }, duration);

    return () => {
      clearInterval(interval);
    };

  }, [selectedIndex, bannerItems]);

  const dispatch = useDispatch();
  const onRestModal = () => {
    dispatch(disableAllMenu());
    dispatch(isActiveResetModal());
  };
  const onClickOut = () => {
    dispatch(disableAllMenu());
  };

  /* 셋팅매뉴 클릭시 다른 메뉴창 닫힘 */
  const onSettingMenu = () => {
    if (sideMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    if (quickMenuStatus) {
      dispatch(isActiveQuickMenu());
    }
    if (expandImageModalStatus) {
      dispatch(isActiveExpandImageModal());
    }
    dispatch(isActiveSettingMenu());
  };

  /* 사이드메뉴 클릭시 다른 메뉴창 닫힘 */
  const onSideMenu = () => {
    if (settingMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    if (quickMenuStatus) {
      dispatch(isActiveQuickMenu());
    }
    if (expandImageModalStatus) {
      dispatch(isActiveExpandImageModal());
    }
    dispatch(isActiveSideMenu());
  };
  const reLoad = () => {
    window.location.reload();
  };

  // 창 닫을 때 부모창으로 메세지 전송
  window.addEventListener('beforeunload', (e) => {
    window.opener.postMessage('closeChatBot', '*');
  })

  const onChatView = () => {
    dispatch(disableAllMenu());
    dispatch(isActiveCloseChatModal());
  };


  return (
    <header className="_chat_header">
      <div className="_left_div">
        <button type="button" aria-label="퀵메뉴" title="퀵메뉴"
          className={sideMenuStatus ? 'menu-trigger active-7' : 'menu-trigger type7'}
          onClick={() => {
            onSideMenu();
          }}
        >
          <span />
          <span />
          <span />
        </button>
        <IconButton
          // icon="ri-settings-3-line round"
          icon="ri-settings"
          styleDef={{
            // borderRadius: '0px',
            // color: '#FFF',
            // transform: settingMenuStatus ? 'rotate(180deg)' : 'rotate(0deg)',
            // // opacity: settingMenuStatus ? '1' : '0.5',
            // opacity: '1',
            // transition: settingMenuStatus ? '0.5s' : '0.5s',
            // strokeWidth: '40px',
            // fontSize: '30px'
            // marginLeft: '70px'
          }}
          viewStatus=""
          clickEvt={onSettingMenu}
          title="화면 설정"
          label="화면 설정"
        />
      </div>
      <div className="_center_div">
        <div className="_title" onClick={() => onRestModal()}>
          <p>제대군인지원센터 상담사 보보</p>
        </div>
      </div>
      <div className="_right_div">
        <IconButton
          // icon="ri-home-4-line"
          icon="ri-restart"
          styleDef={{ paddingTop: "3px" }}
          viewStatus=""
          clickEvt={() => { onRestModal() }}
          title="대화창 새로고침"
          label="대화창 새로고침"
        />

        {/* <IconButton icon="ri-menu-fill" styleDef={{ borderRadius: '0px', color: '#FFF' }} viewStatus="" clickEvt={onSideMenu} /> */}
        <IconButton icon="ri-close-line" styleDef={{}} viewStatus="" title="챗봇 창 닫기" label="챗봇 창 닫기" clickEvt={() => onChatView()} />

      </div>

      <div className="setting" style={{ display: settingMenuStatus || sideMenuStatus || quickMenuStatus ? 'block' : 'none' }} onClick={() => onClickOut()} />

      <LeftSettingMenu styleDef={{ height: settingMenuStatus ? '150px' : '0px', display: settingMenuStatus ? 'block' : 'none' }} />

      <SideMenu styleDef={{ width: sideMenuStatus ? '240px' : '0px', display: sideMenuStatus ? 'block' : 'none' }} />

      <div className="_banner">
        <img className='sound' src='/chat/images/icon_banner_sound.svg' alt='배너 로고' />
        <div className='slider'>
          <div className='slider-view' ref={sliderRef}>
            {bannerItems.map((item, idx) => (
              <div key={idx} className='slider-item'>
                {item}
              </div>
            ))}
            <div className='slider-item'>
              {bannerItems[0]}
            </div>
          </div>
        </div>
      </div>

    </header>
  );
};

ChatHeader.propTypes = {
  title: PropTypes.string,
  viewType: PropTypes.string,
};
ChatHeader.defaultProps = {
  title: '',
  viewType: '',
};
export default ChatHeader;
